<template>
  <!-- Placeholder selama New_CataloguerForm belum dirender (form config masih dimuat).
       Layout meniru New_CataloguerForm: tabel item, strip tab, lalu card isi tab. -->
  <div class="cataloguer-form-skeleton" aria-busy="true" aria-label="Loading">
    <div class="table-responsive mb-3">
      <table class="table mb-0">
        <thead>
          <tr>
            <th v-for="col in columns" :key="`h-${col}`"><Skeleton height="14px" width="70%" /></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="`r-${row}`">
            <td v-for="col in columns" :key="`c-${row}-${col}`"><Skeleton height="16px" /></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex mb-3" style="gap: 12px;">
      <Skeleton v-for="tab in tabs" :key="`t-${tab}`" width="110px" height="28px" />
    </div>

    <div class="row g-3">
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-header pt-3 pb-2 px-3">
            <Skeleton width="140px" height="16px" />
          </div>
          <div class="card-body pt-0 px-3">
            <div v-for="i in 4" :key="`f-${i}`" class="row g-2 mt-1">
              <div class="col-md-6"><Skeleton height="14px" class="mb-1" /><Skeleton height="32px" /></div>
              <div class="col-md-6"><Skeleton height="14px" class="mb-1" /><Skeleton height="32px" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CataloguerFormSkeleton',
  props: {
    rows: { type: Number, default: 5 },
    columns: { type: Number, default: 6 },
    tabs: { type: Number, default: 4 },
  },
};
</script>
